import { render } from "./QuickStart.vue?vue&type=template&id=516f2f28"
import script from "./QuickStart.vue?vue&type=script&lang=js"
export * from "./QuickStart.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__